import React from "react";
import "./App.css";
import Navbar from "./components/portfolio/Navbar";
import Hero from "./components/portfolio/Hero";
import QuestLog from "./components/portfolio/QuestLog";
import OffDuty from "./components/portfolio/OffDuty";
import { SkillTree, Achievements, Contact, Footer } from "./components/portfolio/Arsenal";
import { TooltipProvider } from "./components/ui/tooltip";

function App() {
  return (
    <TooltipProvider>
      <div className="min-h-screen bg-[#050508] text-zinc-100">
        <Navbar />
        <main>
          <Hero />
          <div id="stats" />
          <QuestLog />
          <SkillTree />
          <Achievements />
          <OffDuty />
          <Contact />
        </main>
        <Footer />
      </div>
    </TooltipProvider>
  );
}

export default App;
